module.exports = __webpack_public_path__ + "static/media/nsa1.13173af2.jpg";